import { Button, Col, Result, Row, Typography } from 'antd';
import React from 'react';
import useAuthenticationCode from '../hooks/useAuthenticationCode';
import gitLabLogo from '../images/gitlab.png';
import { useNavigate } from 'react-router-dom';
import { Page } from 'osep-react-antd';
import packageJson from '../../package.json';
import config from '../config';

const ConnectToGitLabPage: React.FC = () => {
  const { startAuthentication } = useAuthenticationCode();
  const navigate = useNavigate();

  return (
    <Page
      title="Connect to GitLab"
      onBack={() => navigate(-1)}
      footer={<Typography.Text disabled>{packageJson.version}</Typography.Text>}
    >
      <Row justify="center" align="middle" style={{ height: '40vh' }}>
        <Col>
          <Result
            status="error"
            icon={<img src={gitLabLogo} style={{ width: '100px' }} alt="" />}
            title="You're not connected to GitLab"
            subTitle="To create a project, you need to connect the OSEP Generator with your GitLab account."
            extra={[
              <Button
                type="primary"
                onClick={() =>
                  startAuthentication &&
                  startAuthentication(
                    `${config.gitlabAuthUrl}/authorize?client_id=${config.gitlabClientId}&response_type=code&scope=${config.gitlabScope}`,
                    `${config.basePath}/gitlab/redirect-receiver`,
                  )
                }
              >
                Connect to GitLab
              </Button>,
            ]}
          />
        </Col>
      </Row>
    </Page>
  );
};

export default ConnectToGitLabPage;
